import React from 'react';
import { FilterState, LoanOfficer } from '../../types/throughput';
import { Button } from '../ui/Button';
import { RotateCcw } from 'lucide-react';
interface FilterBarProps {
  filters: FilterState;
  setFilters: (filters: FilterState) => void;
  officers: LoanOfficer[];
  onRefresh: () => void;
}
export function FilterBar({
  filters,
  setFilters,
  officers,
  onRefresh
}: FilterBarProps) {
  const svps = Array.from(new Set(officers.filter(o => o.role === 'SVP').map(o => JSON.stringify({
    id: o.id,
    name: o.name
  })))).map(s => JSON.parse(s));
  const teamLeads = Array.from(new Set(officers.filter(o => o.role === 'Team Lead').map(o => JSON.stringify({
    id: o.id,
    name: o.name
  })))).map(s => JSON.parse(s));
  const loanOfficers = officers.filter(o => o.role === 'Loan Officer');
  const inputClass = 'h-9 px-3 text-sm bg-white border border-[#E5E5E5] rounded-md focus:outline-none focus:ring-2 focus:ring-[#7C3AED]/20 focus:border-[#7C3AED] transition-colors';
  const labelClass = 'block text-xs font-medium text-[#706E6B] mb-1.5';
  const handleScopeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    if (val === 'All') {
      setFilters({
        ...filters,
        scopeType: 'All',
        selectedScopeId: undefined
      });
    } else {
      const [type, id] = val.split('::');
      setFilters({
        ...filters,
        scopeType: type as any,
        selectedScopeId: id
      });
    }
  };
  const currentScopeValue = filters.scopeType === 'All' ? 'All' : `${filters.scopeType}::${filters.selectedScopeId}`;
  return <div className="sticky top-0 z-30 w-full bg-white border-b border-[#E5E5E5] shadow-sm" data-id="element-6">
      <div className="max-w-[1600px] mx-auto px-6 py-4" data-id="element-7">
        <div className="flex items-end justify-between" data-id="element-8">
          <div className="flex items-end gap-6" data-id="element-9">
            {/* Date Range */}
            <div className="flex items-end gap-2" data-id="element-10">
              <div data-id="element-11">
                <label className={labelClass} data-id="element-12">Start Date</label>
                <input type="date" value={filters.dateRange.start} onChange={e => setFilters({
                ...filters,
                dateRange: {
                  ...filters.dateRange,
                  start: e.target.value
                }
              })} className={`${inputClass} w-[140px]`} data-id="element-13" />
              </div>
              <span className="text-[#CCCCCC] pb-2" data-id="element-14">–</span>
              <div data-id="element-15">
                <label className={labelClass} data-id="element-16">End Date</label>
                <input type="date" value={filters.dateRange.end} onChange={e => setFilters({
                ...filters,
                dateRange: {
                  ...filters.dateRange,
                  end: e.target.value
                }
              })} className={`${inputClass} w-[140px]`} data-id="element-17" />
              </div>
            </div>

            {/* Scope */}
            <div data-id="element-18">
              <label className={labelClass} data-id="element-19">Scope</label>
              <select value={currentScopeValue} onChange={handleScopeChange} className={`${inputClass} w-[240px]`} data-id="element-20">
                <option value="All" data-id="element-21">All Loan Officers</option>
                <optgroup label="SVPs" data-id="element-22">
                  {svps.map((svp: any) => <option key={`SVP::${svp.id}`} value={`SVP::${svp.id}`} data-id="element-23">
                      {svp.name}
                    </option>)}
                </optgroup>
                <optgroup label="Team Leads" data-id="element-24">
                  {teamLeads.map((tl: any) => <option key={`Team Lead::${tl.id}`} value={`Team Lead::${tl.id}`} data-id="element-25">
                      {tl.name}
                    </option>)}
                </optgroup>
                <optgroup label="Loan Officers" data-id="element-26">
                  {loanOfficers.map(lo => <option key={`Loan Officer::${lo.id}`} value={`Loan Officer::${lo.id}`} data-id="element-27">
                      {lo.name}
                    </option>)}
                </optgroup>
              </select>
            </div>
          </div>

          <div data-id="element-28">
            <Button variant="neutral" onClick={onRefresh} data-id="element-29">
              <RotateCcw className="h-4 w-4 mr-2" data-id="element-30" />
              Refresh
            </Button>
          </div>
        </div>
      </div>
    </div>;
}